import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../components/ModalProvider';

import { AlertTriangle } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

interface UsePublishDialogProps {
    onPublish: () => Promise<void>;
}

export function usePublishDialog({ onPublish }: UsePublishDialogProps) {
    const { t } = useTranslation();
    const { pushError } = useModalContext() as any;
    const [isOpen, setIsOpen] = useState(false);

    const openPublishDialog = () => {
        setIsOpen(true);
    };

    const closePublishDialog = () => {
        setIsOpen(false);
    };

    const PublishDialog = () => (
        <Dialog
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) closePublishDialog();
            }}
        >
            <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle>{t('settingsPanel.agentPanel.publishServer')}</DialogTitle>
                </DialogHeader>
                <Alert variant="warning">
                    <AlertTriangle aria-hidden className="h-4 w-4" />
                    <AlertDescription>
                        Veröffentlichen eines REAL GAIN/MCP-Servers ermöglicht es anderen Nutzern, unmittelbar auf ihn zuzugreifen.
                    </AlertDescription>
                </Alert>
                <DialogFooter className="gap-2 pt-4 sm:gap-0">
                    <Button variant="outline" onClick={closePublishDialog}>
                        {t('global.cancel')}
                    </Button>
                    <Button
                        onClick={async () => {
                            try {
                                await onPublish();
                                closePublishDialog();
                            } catch (error) {
                                pushError(error);
                            }
                        }}
                    >
                        Veröffentlichen
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );

    return {
        PublishDialog,
        openPublishDialog,
        closePublishDialog
    };
}
